import { styled } from '@mui/material/styles';

export const HelperText = styled('div')`
  color: #8f8f8f;
  font-size: 0.8rem;
`;
